var FetchStatus;
(function (FetchStatus) {
    FetchStatus["idle"] = "idle";
    FetchStatus["loading"] = "loading";
    FetchStatus["succeeded"] = "succeeded";
    FetchStatus["failed"] = "failed";
})(FetchStatus || (FetchStatus = {}));
var SortOptions;
(function (SortOptions) {
    SortOptions["LATEST"] = "Latest";
    SortOptions["TOP_RATED"] = "Top Rated";
    SortOptions["OLDEST"] = "Oldest";
    SortOptions["NAME"] = "Name";
})(SortOptions || (SortOptions = {}));
export { FetchStatus, SortOptions };
